import appSettings from 'wanderu-config';

import { FacebookUnableToAuthenticateUserError } from '../Errors';
import { parseFacebookResponse } from '../utils';

async function _ensureSDKLoaded() {
    if (window.FB) {
        return;
    }

    return new Promise((resolve) => {
        window.fbAsyncInit = () => {
            window.FB.init(appSettings.config.facebook);
            window.FB.AppEvents.logPageView();

            resolve();
        };

        (function(d, s, id) {
            var js;
            var fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.async = true;
            js.src = '//connect.facebook.net/en_US/sdk.js';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    });
}

async function getLoggedInUser() {
    await _ensureSDKLoaded();

    return new Promise((resolve) => {
        window.FB.api('/me', {
            fields: 'first_name, last_name, email',
        }, (response) => {
            resolve(parseFacebookResponse(response));
        });
    });
}

async function getLoggedInState() {
    await _ensureSDKLoaded();

    return new Promise((resolve) => {
        if (!window.FB) {
            return resolve({
                isLoggedIn: false,
            });
        }

        window.FB.getLoginStatus((response) => {
            return resolve({
                isLoggedIn: response.status === 'connected',
                accessToken: response.authResponse && response.authResponse.accessToken,
            });
        }, true);
    });
}

async function logIn() {
    await _ensureSDKLoaded();

    return new Promise((resolve, reject) => {
        window.FB.login((response) => {
            if (!response.authResponse) {
                return reject(new FacebookUnableToAuthenticateUserError());
            }

            resolve(response.authResponse.accessToken);
        }, { scope: 'email' });
    });
}

async function logOut() {
    await _ensureSDKLoaded();

    const { isLoggedIn } = await getLoggedInState();

    if (!isLoggedIn) {
        return;
    }

    return _performLogOut();
}

async function _performLogOut() {
    return new Promise((resolve) => {
        window.FB.logout((response) => {
            resolve();
        });
    });
}

export { getLoggedInState };
export { logIn };
export { logOut };
export default {
    getLoggedInState,
    getLoggedInUser,
    logIn,
    logOut,
};
